"use client";
import Link from "next/link";
import ArrowLeft from "../Svg/ArrowLeft";
import { useRouter } from "next/navigation";

interface BreadcrumbLink {
  id?: number;
  to: string;
  title: string | JSX.Element;
}

interface BreadcrumbProps {
  links: BreadcrumbLink[];
  className?: string;
}

export default function Breadcrumb({ links, className }: BreadcrumbProps) {
  const router = useRouter();

  const handleRefresh = () => {
    router.refresh();
  };

  return (
    <section className={`breadcrumb ${className}`}>
      <div className="container">
        <div className="breadcrumb__content">
          <ul className="breadcrumb__list flex gap-3">
            {links.map((link, index) => (
              <li
                key={link.id ?? index}
                className="breadcrumb__item flex items-center gap-3"
              >
                {index === links.length - 1 ? (
                  // اگر لینک آخر باشد، دکمه برای رفرش صفحه
                  <button
                    onClick={handleRefresh}
                    className="sm:text-base text-xs text-ws-gray-400 last:text-ws-gray-600"
                  >
                    {link.title}
                  </button>
                ) : (
                  // لینک‌های معمولی برای سایر موارد
                  <Link
                    href={`/${link.to}`}
                    className="sm:text-base text-xs text-ws-gray-400 last:text-ws-gray-600"
                  >
                    {link.title}
                  </Link>
                )}
                {index < links.length - 1 && <ArrowLeft />}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
